import React from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import styles from './SharedLayout.module.scss';

interface SharedLayoutProps {
    children: React.ReactNode;
}

const SharedLayout: React.FC<SharedLayoutProps> = ({ children }) => {
    const [isSidebarExpanded, setIsSidebarExpanded] = React.useState(false);

    return (
        <Box className={styles.layoutScreen}>
            <Sidebar 
                isExpanded={isSidebarExpanded} 
                onToggle={(val) => setIsSidebarExpanded(val)} 
            />
            <Box 
                className={styles.content}
                sx={{ 
                    marginLeft: { 
                        xs: 0, 
                        md: isSidebarExpanded ? '250px' : '80px' 
                    },
                    minWidth: 0,
                    overflowX: 'hidden',
                }}
            >
                {children}
            </Box>
        </Box>
    );
};

export default SharedLayout;
